import { CoachSessionType, Maybe } from 'graphql/types';

export interface SessionTrackingMetadata {
  /** Event name sent when the session card is clicked on the home schedule */
  cardClickEventName: string;
  eventCategory: string;
  eventSubcategory: string;
}

const coachingSessionTracking: SessionTrackingMetadata = {
  cardClickEventName: 'view_coach_session_detail',
  eventCategory: 'coach',
  eventSubcategory: 'consults',
};

export const sessionTrackingByType: Record<
  CoachSessionType,
  SessionTrackingMetadata
> = {
  [CoachSessionType.PersonalTraining]: {
    cardClickEventName: 'view_coach_session_detail',
    eventCategory: 'coach',
    eventSubcategory: 'personal training',
  },
  [CoachSessionType.UserNutritionConsult]: {
    cardClickEventName: 'view_dietitian_session_detail',
    eventCategory: 'nutrition',
    eventSubcategory: 'consults',
  },
  [CoachSessionType.CoachingSession]: coachingSessionTracking,
  [CoachSessionType.UserCoachingConsult]: coachingSessionTracking,
};

/**
 * Mixpanel metadata for a coach session. Sessions without a type are
 * treated as coaching sessions, matching how they are displayed.
 * @param sessionType The session's type
 * @returns SessionTrackingMetadata - The tracking metadata for the type
 */
export const getSessionTracking = (
  sessionType?: Maybe<CoachSessionType>,
): SessionTrackingMetadata =>
  sessionTrackingByType[sessionType ?? CoachSessionType.CoachingSession];
